// extracted by mini-css-extract-plugin
export var active = "MenuEntry-module--active--3997e";
export var headerWithOpaqueBackground = "MenuEntry-module--headerWithOpaqueBackground--c94e1";
export var hideInDesktop = "MenuEntry-module--hideInDesktop--b596a";
export var link = "MenuEntry-module--link--5e807";
export var morePaddingLeft = "MenuEntry-module--morePaddingLeft--b2c99";